import styled from '@emotion/styled'
import { gsColors } from '../../styles/Variables';

export const ResetFormWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .reset-password-content{
    padding-top: 2rem;
    max-width: 1440px;
    width: 80%;
    display: flex;
    flex-direction: column;
  }

  .inputs-container{
    max-width: 325px;
    width: 100%;
    margin: 50px 0;

    .input-item{
      position: relative;
      margin-bottom: 30px;

      input{
        padding-left: 30px;
      }

      label{
        color: ${gsColors.darkEggplant};
        font-size: 12px;
        letter-spacing: 0.5px;
        text-transform: uppercase;
      }

      svg{
        position: absolute;
        left: 0;
        bottom: 10px;

        &:hover{
          cursor: pointer;
        }
      }
    }
  }
`